import $ from "jquery";
import "./jquery-highlight";

function testContent(elt, re) {
	return re.test(elt.textContent || elt.innerText);
}

function defaultFindHook(container, children, re, ww) {
	return $(container).children(children).each(function() {
		$(this).toggle(testContent(this, re));
	}).unhighlight().highlight(ww);
}

function tableFindHook(container, _children, re, ww) {
	return $(container).find(">tbody>tr").each(function() {
		var r = $(this);
		r.toggle(r.children("td").is(function() { return testContent(this, re); }));
	}).unhighlight().highlight(ww);
}

function suppressEnter(e) {
	if(e.keyCode == 13) return false;
}

var defaults = { selector: ".fs-searchable", suppressEnter: true };

$.fn.quicksearch = function(arg) {
	var options = $.extend({}, defaults, arg);
	if(options.suppressEnter)
		this.on("keydown", suppressEnter);
	return this.each(function() {
		var timer = 0;
		var oldvalue = this.value;
		$(this).on("keyup mouseup",
			function(e) {
				if(timer !== 0) clearTimeout(timer);
				timer = setTimeout(function() {
					timer = 0;
					var value = e.target.value;
					if(value != oldvalue) {
						oldvalue = value;
						var ww = $.grep(value.split(" "), function(w) { return w !== ''; });
						var re = new RegExp($.map(ww, function(w) { return w.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"); }).join(".*"), "i");
						$(options.selector).each(function() {
							(this.tagName == "TABLE" ? tableFindHook : defaultFindHook)(this, options.children, re, ww);
						});
					}
				}, 500);
			});
	});
};
